import { UtilitiesService } from 'src/ng2/shared/services/utilities/utilities.service';
import { CreditGapsFreeformCourseModalCtrl } from './credit-gap-freeform-course-modal.controller';

interface ITermDetails {
  termType: 'CURRENT' | 'NEXT' | 'FUTURE';
  value: number | null;
}

export class CreditGapFreeformCourseModal {
  static $inject = ['$mdDialog', 'UtilitiesService'];

  constructor(private $mdDialog, private utils: UtilitiesService) {}

  /**
   *
   * @param courses These should be merged courses from both master schedule AND code deck
   */
  show(termDetails: ITermDetails, student, school, studentGapPlans, gapPlan?) {
    const { termType, value: termYear } = termDetails;

    let modalTitle;
    switch (termType) {
      case 'FUTURE':
        modalTitle = 'Add plan to future term';
        break;
      case 'CURRENT':
        modalTitle = 'Add plan to this term';
        break;
      case 'NEXT':
        const termYearHuman = this.utils.getHumanReadableTerm(termYear);
        modalTitle = `Add plan to term ${termYearHuman}`;
        break;
      default:
        throw new Error(`termDetails termType of ${termType} is not valid`);
    }

    return this.$mdDialog.show({
      disableParentScroll: true,
      template: require('./credit-gap-freeform-course-modal.html'),
      parent: angular.element(document.body),
      clickOutsideToClose: true,
      controller: CreditGapsFreeformCourseModalCtrl,
      controllerAs: '$ctrl',
      locals: {
        termType,
        termYear,
        modalTitle,
        student,
        school,
        studentGapPlans,
        gapPlan,
      },
    });
  }
}
